export default "__VITE_ASSET__CikmYMRZ__"